import { IClientUsers } from '@llws/platform-shared-types/types/api/perms-api';
import { ActionContext } from 'vuex';
import { IQueryCommandOptions, convertQueryCommandToQueryString } from '@llws/dynamic-router-utils';
import { adminRequest } from '@/shared/request-configs/admin-request';
import { IStateStrict } from '@/shared/interfaces/store-base';

interface IPermsApiClientUsersState extends IStateStrict<Partial<IClientUsers>> {
  user: IClientUsers,
  users: Record<string, IClientUsers>
}

export default {
  namespaced: true,

  state: {
    user: {},
    users: {},
  } as IPermsApiClientUsersState,

  getters: {
    user: (state: IPermsApiClientUsersState) => state.user,
    users: (state: IPermsApiClientUsersState) => ({ ...state.users }),
    usersAsArray: (state: IPermsApiClientUsersState): (IClientUsers & { id: number })[] => Object
      .keys(state.users)
      .map((key) => ({
        ...state.users[key],
        id: Number(key),
      })),
  },

  mutations: {
    setUser: (state: IPermsApiClientUsersState, payload: IClientUsers) => {
      state.user = payload;
    },
    setUsers: (state: IPermsApiClientUsersState, payload: Record<string, IClientUsers>) => {
      state.users = payload;
    },
  },

  actions: {
    getUsers: async (ctx: ActionContext<Partial<IClientUsers>, null>, payload: IQueryCommandOptions | undefined) => {
      const response = await adminRequest.get<Record<string, IClientUsers>>(
        `/v0/perms-api/clients/users${payload ? convertQueryCommandToQueryString(payload) : ''}`,
      );
      ctx.commit('setUsers', response.data ?? {});
    },
    getUser: async (ctx: ActionContext<Partial<IClientUsers>, null>, payload: { id: string } & IQueryCommandOptions) => {
      const response = await adminRequest.get<Record<string, IClientUsers>>(
        `/v0/perms-api/clients/users${payload ? convertQueryCommandToQueryString(payload) : ''}`,
      );
      ctx.commit('setUser', response.data?.[payload.id] ?? {});
    },
    setPrimaryAdmin: async (ctx: ActionContext<Partial<IClientUsers>, null>, userId: string) => {
      await adminRequest.put(`/v0/perms-api/primary-owner`, { userId });
    },
  },
};
